import { VAT_RATE_SINCE_2025_07 } from "./vat/vat.js";

export const ADOBE_AMOUNT = 1218;
export const ADOBE_REVERSE_VAT = Math.round(VAT_RATE_SINCE_2025_07 * ADOBE_AMOUNT);
